class Header {
    constructor() {
        this.window = window;
        this.header = document.querySelector('.js-header');
        this.burgerButton = document.querySelector('.js-burger-toggle');
        this.burgerNav = document.querySelector('.js-burger-nav');
        this.burgerDropdownToggles = document.querySelectorAll('.js-burger-dropdown-toggle');
        this.timer = null;

        if (this.burgerButton && this.burgerNav) {
            this.burgerButton.addEventListener('click', (event) => {
                this.burgerButton.classList.toggle('is-open');
                this.burgerNav.classList.toggle('is-open');
                if (this.burgerNav.classList.contains('is-open')) {
                    document.querySelector('body')?.classList.add('no-scroll');
                } else {
                    document.querySelector('body')?.classList.remove('no-scroll');
                }
            });
        }

        this.burgerDropdownToggles.forEach((toggle) => {
            toggle.addEventListener('click', (event) => {
                event.preventDefault();
                event.currentTarget.closest('.js-burger-dropdown-item')?.classList.toggle('is-open');
            });
        });
    }
}

const header = {
    init() {
        return new Header();
    },
};

export default header;
